<template>
    <div class="activate-container">
        <div class="banner-wrap">
            <el-carousel height="100vh">
                <el-carousel-item :key="item" v-for="item in bannerList">
                    <el-image :src="require(`@/assets/image/login/${item}`)" fit="contain"></el-image>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="activate-wrap">
            <div class="activate-box">
                <el-image :src="require('@/assets/image/activate/banner.jpg')" :lazy="true"></el-image>
                <!-- <div class="activate-box-header">
                    <h2 class="activate-box-title">
                        JewelOra Account Activate
                    </h2>
                    <el-button
                        class="sign-in-btn"
                        type="danger"
                        @click="$router.push('/login')"
                        >Sign in</el-button
                    >
                </div> 
                <div class="activate-box-tip">
                    Welcome JewelOra Members,we got $10 CMOFFER for you! Please
                    activate CMOFFER account with your JewelOra account email.
                </div>-->
                <div class="activate-box-desc">
                    <p class="activate-box-desc-title">
                        Welcome JewelOra Members! Activate with JewelOra member
                        email, and get $10 coupon!
                    </p>
                    <ul class="about-cmoffer-ul">
                        <li>About CMOffer</li>
                        <li>1 API Publish to Shopify/Shoplazza, etc</li>
                        <li>2 Automatic Order Sync</li>
                        <li>3 Dropshipping to Worldwide</li>
                        <li>4 Over 10000 Winning Product Arriving!</li>
                        <li>5 Thousands of Under $4 Products Launching!</li>
                    </ul>
                </div>
                <div class="activate-box-form">
                    <el-form :model="activateForm" :rules="rules" :show-message="true" class="form-wrap"
                        ref="activateForm" @keydown.enter.native.prevent>
                        <el-form-item label="Email" prop="email" :error="rules.email[0].error">
                            <el-input @blur="
                                transformLabel(
                                    0,
                                    'blur',
                                    activateForm.email
                                )
                            " @clear="
    transformLabel(
        0,
        'blur',
        activateForm.email
    )
" @focus="transformLabel(0, 'focus')" @keyup.enter.native="save" clearable
                                maxlength="100" ref="email" v-model="activateForm.email"></el-input>
                        </el-form-item>
                        <el-form-item label="Verification Code" prop="code" :error="rules.code[0].error">
                            <el-input @blur="
                                transformLabel(1, 'blur', activateForm.code)
                            " @clear="
    transformLabel(1, 'blur', activateForm.code)
" @focus="transformLabel(1, 'focus')" @keyup.enter.native="save" maxlength="100"
                                ref="code" type="password" show-password clearable v-model="activateForm.code">
                                <el-button class="send-btn" slot="append" type="primary" :disabled="countIng"
                                    @click="send">{{ count }}
                                    <span v-show="countIng">s</span>
                                </el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="New password" prop="password">
                            <el-input @blur="
                                transformLabel(
                                    2,
                                    'blur',
                                    activateForm.password
                                )
                            " @clear="
    transformLabel(
        2,
        'blur',
        activateForm.password
    )
" @focus="transformLabel(2, 'focus')" @keyup.enter.native="save" maxlength="100"
                                ref="password" show-password clearable type="password" v-model="activateForm.password">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="Confirm new password" prop="password_confirmation">
                            <el-input @blur="
                                transformLabel(
                                    3,
                                    'blur',
                                    activateForm.password_confirmation
                                )
                            " @clear="
    transformLabel(
        3,
        'blur',
        activateForm.password_confirmation
    )
" @focus="transformLabel(3, 'focus')" @keyup.enter.native="save" maxlength="100"
                                ref="password_confirmation" show-password clearable type="password"
                                v-model="activateForm.password_confirmation"></el-input>
                        </el-form-item>
                        <el-button :class="[
                            'activate-btn',
                            {
                                'activate-submit-btn':
                                    activateForm.forgot_name &&
                                    activateForm.forgot_password,
                            },
                        ]" :disabled="disabled" @click="save()">Activate</el-button>
                        <div class="privacy-policy-div">
                            <span>Already activated?</span>
                            <el-button type="text" @click="$router.replace('/login')">Sign In</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import util from "@/utils/util.js";
export default {
    data() {
        var validatePwd = (rule, value, callback) => {
            if (value.length< 6) {
                callback(new Error("The password must be at least 6 characters."));
            } else if (!/^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])\S*$/.test(value)) {
                callback(new Error("The password must contain uppercase letters, lowercase letters, and digits."));
            } else {
                callback();
            }
        };
        var validatePwdConfirm = (rule, value, callback) => {
            if (value.length< 6) {
                callback(new Error("The password must be at least 6 characters."));
            } else if (!/^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])\S*$/.test(value)) {
                callback(new Error("The password must contain uppercase letters, lowercase letters, and digits."));
            } else if (value !== this.activateForm.password) {
                callback(new Error("The two passwords are inconsistent!"));
            } else {
                callback();
            }
        };
        return {
            activateForm: {
                email: "",
                code: "",
                password: "",
                password_confirmation: "",
                activate: 1,
            },
            rules: {
                email: [
                    {
                        required: true,
                        message: "Please input",
                        trigger: "blur",
                        error: "",
                    },
                ],
                code: [
                    {
                        error: "",
                    },
                ],
                password: [
                   {
                        validator: validatePwd,
                        trigger: "blur",
                    }, 
                ],
                password_confirmation: [
                    {
                        validator: validatePwdConfirm,
                        trigger: "blur",
                    },
                ],
            },
            checked: false,
            loading: false,
            formItemLabels: null,
            bannerList: ["banner-1.jpg", "banner-2.jpg"],
            count: "Send",
            timer: null,
            countIng: false,
        };
    },
    created() {
        this.getRouterData();
    },
    mounted() {
        this.initFormItemLabel();
    },
    watch: {
        ["activateForm.email"]: {
            handler(val) {
                this.$nextTick(() => {
                    if (this.formItemLabels) {
                        if (val) {
                            this.transformLabel(0, "focus");
                        }
                    }
                });
            },
            immediate: true,
        },
        ["activateForm.code"]: {
            handler(val) {
                this.$nextTick(() => {
                    if (this.formItemLabels) {
                        if (val) {
                            this.transformLabel(1, "focus");
                        }
                    }
                });
            },
            immediate: true,
        },
        ["activateForm.password"]: {
            handler(val) {
                this.$nextTick(() => {
                    if (this.formItemLabels) {
                        if (val) {
                            this.transformLabel(2, "focus");
                        }
                    }
                });
            },
            immediate: true,
        },
        ["activateForm.password_confirmation"]: {
            handler(val) {
                this.$nextTick(() => {
                    if (this.formItemLabels) {
                        if (val) {
                            this.transformLabel(3, "focus");
                        }
                    }
                });
            },
            immediate: true,
        },
    },
    methods: {
        validateEmail() {
            if (!util.isEmail(this.activateForm.email)) {
                this.rules.email[0].error = "Incorrect email format";
                return false;
            } else {
                this.rules.email[0].error = "";
                return true;
            }
        },
        save() {
            this.rules.code[0].error = "";
            this.$refs["activateForm"].validate((valid) => {
                if (valid) {
                    if (!this.validateEmail()) return;
                    this.loading = true;
                    this.$ga.event(
                        "engagement",
                        "mem_activate",
                    );
                    cmofferApi
                        .resetPassword({ ...this.activateForm }, "post")
                        .then((res) => {
                            this.loading = false;
                            const { errcode, data, errmsg } = res;
                            if (data === 1) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "成功"
                                        : "Success"
                                );
                                this.$router.push({
                                    path: "/login",
                                });
                                this.$ga.event(
                                    "engagement",
                                    "mem_activate_success",
                                );
                            } else {
                                this.$message.error(
                                    this.$i18n.locale == "zh" ? "错误" : errmsg
                                );
                            }
                        });
                } else {
                    return false;
                }
            });
        },
        transformLabel(i, type, val) {
            if (type == "focus") {
                this.formItemLabels[
                    i
                ].className = `el-form-item__label is-foucs`;
            } else if (type == "blur" && !val) {
                this.formItemLabels[i].className = `el-form-item__label`;
            }
        },
        initFormItemLabel() {
            this.formItemLabels = document.querySelectorAll(
                ".el-form-item__label"
            );
        },
        send() {
            if (this.activateForm.email) {
                if (!this.validateEmail()) return;
                cmofferApi
                    .verificationEmailCode(
                        {
                            email: this.activateForm.email,
                        },
                        "post"
                    )
                    .then((res) => {
                        if (res.errcode == 0) {
                            /* this.$message.success(
                                "Please also check your spam or junk mail folder."
                            ); */
                            this.rules.code[0].error =
                                "Please also check your spam or junk folder.";
                            const timeCount = 60;
                            if (!this.timer) {
                                this.countIng = true;
                                this.count = timeCount;
                                this.timer = setInterval(() => {
                                    if (
                                        this.count > 0 &&
                                        this.count <= timeCount
                                    ) {
                                        this.count--;
                                    } else {
                                        clearInterval(this.timer);
                                        this.timer = null;
                                        this.countIng = false;
                                        this.count = "Send";
                                    }
                                }, 1000);
                            }
                        }
                    });
            }
        },
        getRouterData() {
            let { query } = this.$route;
            this.activateForm.email = query.email;
        },
    },
};
</script>
<style lang="scss" scoped>
.activate-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    position: relative;

    .banner-wrap {
        flex: 0 1 550px;
        background: #373330;
        transition: all 0.6s;

        ::v-deep .el-carousel {
            .el-carousel__item {
                &:nth-child(odd) {
                    background: #d3dce6;
                }

                &:nth-child(even) {
                    background: #99a9bf;
                }
            }

            .el-carousel__arrow {
                display: none;
            }

            .el-carousel__indicators--horizontal {
                bottom: 50px;

                .el-carousel__indicator--horizontal {
                    .el-carousel__button {
                        width: 22px;
                        height: 7px;
                        border-radius: 4px;
                    }
                }

                .is-active {
                    .el-carousel__button {
                        width: 44px;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 900px) {
        .banner-wrap {
            flex: 0 1 0;
        }
    }

    .activate-wrap {
        flex: 1 1 auto;
        background: #ffffff;
        position: relative;
        text-align: left;

        .activate-box {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            // min-width: 490px;
            width: 510px;
            min-height: 480px;
            padding: 10px;
            color: $color-000000a6;
            box-sizing: border-box;

            .activate-box-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 20px 0 30px;

                .activate-box-title {
                    font-size: 26px;
                    font-weight: bold;
                    color: #1c2d42;
                }

                .sign-in-btn {
                    float: right;
                    color: #fff;

                    &:hover {
                        background-color: #e30d16;
                        border-color: #e30d16;
                    }
                }
            }

            .activate-box-tip {
                padding: 20px;
                background: #dfecfd;
                font-size: 14px;
                line-height: 20px;
                border: 1px solid #cfe3fc;
                color: $color-black;
            }

            .activate-box-desc {
                margin: 30px 0 0;
                font-weight: 600;
                font-size: 16px;

                &-title {
                    line-height: 20px;
                }

                .about-cmoffer-ul {
                    margin: 20px 0;
                    line-height: 20px;
                    font-size: 15px;
                }
            }

            .activate-box-form {
                margin: 5px 0 0;

                // 修改element 样式
                ::v-deep .el-form {
                    .el-form-item {
                        position: relative;
                        margin-bottom: 18px;

                        .el-form-item__label {
                            color: #a9b7d4;
                            line-height: 18px;
                            transform-origin: 0;
                            transition: transform 0.6s;
                            position: relative;
                            z-index: 10;
                            transform: translateY(25px) scale(1.2);

                            /* &::before {
                                content: "";
                            } */
                            &.is-foucs {
                                transform: translateY(0) scale(1);
                            }
                        }

                        .el-form-item__content {
                            .el-input {
                                z-index: 12;

                                .el-input__inner {
                                    border: none;
                                    border-bottom: 1px solid #eaedf2;
                                    padding: 0 0 15px 3px;
                                    font-size: 16px;
                                    transition: border 0.6s;
                                    background-color: transparent;

                                    &:focus {
                                        border-bottom-color: $color-primary  !important;
                                    }
                                }

                                .el-input-group__append {
                                    background-color: transparent;
                                    border-color: transparent;
                                    border: none;
                                    min-width: 75px !important;
                                    padding: 0 !important;
                                }

                                .send-btn {
                                    color: #ffffff;
                                    background: $color-primary  !important;
                                }
                            }
                        }
                    }

                    .el-form-item.is-error {
                        .el-form-item__content {
                            .el-input {
                                .el-input__inner {
                                    border-bottom-color: #f00;
                                }
                            }
                        }
                    }

                    .activate-btn {
                        color: #fff;
                        min-height: 50px;
                        line-height: 50px;
                        margin: 25px 0 15px;
                        cursor: pointer;
                        background: $color-primary;
                        width: 100%;
                        padding: 0;
                        border-radius: 0.015rem;
                        border: none;
                        outline: none;
                        font-size: 18px;

                        &:hover {
                            color: rgb(240, 240, 240);
                        }
                    }

                    .activate-submit-btn {
                        background: #aed2e1;
                    }

                    .is-disabled {
                        opacity: 0.6;
                        cursor: no-drop;
                    }

                    .privacy-policy-div {
                        text-align: right;
                        color: $color-000000a6;
                        font-size: 13px;

                        span:first-child {
                            margin-right: 5px;
                        }

                        .el-button--text {
                            font-size: 14px;
                            color: $color-primary;
                        }
                    }
                }
            }
        }
    }
}
</style>
